module.exports = __webpack_public_path__ + "img/strophoid_about.8f6f8fab.jpg";